import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';

type Props = {
	id: string;
	displayName: string;
	title: string | null;
	dmSlug: string | null;
	publiclyVisible: boolean;
	trackProfileLinkClick: (id: string) => void;
};

export const NameAndTitle: React.FC<Props> = ({
	id,
	displayName,
	title,
	dmSlug,
	publiclyVisible,
	trackProfileLinkClick,
}) => {
	return (
		<div>
			{publiclyVisible ? (
				<Link
					data-testid="dm-profile-link"
					data-qa="dm-profile-link"
					href={`/decision-makers/${dmSlug || id}?source_location=starter_dashboard`}
					onClick={() => trackProfileLinkClick(id)}
					variant="secondary"
				>
					<Text variant="heading" size="x-small">
						{displayName}
					</Text>
				</Link>
			) : (
				<Text variant="heading" size="x-small">
					{displayName}
				</Text>
			)}
			<br />
			{title && (
				<Text data-testid="dm-title" className="text-typography-weak">
					{title}
				</Text>
			)}
		</div>
	);
};
